import { FC, PropsWithChildren } from 'react';

interface NoGamesStub {
  image: string;
}

export const NoGamesStub: FC<PropsWithChildren & NoGamesStub> = ({ children, image }) => {
  return (
    <>
      <p className="text-sm_no_games_text text-sm font-medium m-auto text-center mt-3 px-3">
        {children}
      </p>
      <img src={image} className="w-[120px] m-auto" alt="providers moon dog" />
    </>
  );
};
